import {
  Component,
  ElementRef,
  HostListener,
  OnInit,
  TemplateRef,
  ViewChild,
  Inject,
  Renderer2,
  inject,
} from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { PLATFORM_ID } from '@angular/core';
import { FormArray } from '@angular/forms';
import { Router } from '@angular/router';
import { NgbCalendar, NgbDate, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { AlertMsgModel, ResultLinkObject } from '../../../interfaces';
import { FlightSearchService } from '../../../services/flight-search/services/flight-search.service';
import { HomePageService } from '../../../services/home-page/services/home-page.service';
import { PopularAirlinesSharedService } from '../../../../components/popular-airlines/services/popular-airlines-shared.service';
import { SharedService } from '../../../services/shared.service';
import Swal from 'sweetalert2';
import {
  Subject,
  debounceTime,
  distinctUntilChanged,
  finalize,
  retry,
  switchMap,
} from 'rxjs';
import { FlightSearchApiService } from '../../../services/flight-search/services/flight-search-api.service';
import { StorageService } from '../../../services/storage-services.service'; // Import the StorageService
import { IAirPortTranslated } from '../../../../components/popular-airlines/models/airlineInfo.models';

@Component({
  selector: 'app-multi-city',
  templateUrl: './multi-city.component.html',
  styleUrls: ['./multi-city.component.scss'],
})
export class MultiCityComponent implements OnInit {
  private isBrowser: boolean;

  searchbox = inject(FlightSearchService);
  homePageService = inject(HomePageService);
  translate = inject(TranslateService);
  sharedService = inject(SharedService);
  router = inject(Router);
  sharedAirlineService = inject(PopularAirlinesSharedService);
  flightSearchApi = inject(FlightSearchApiService);
  storageService = inject(StorageService); // Inject the StorageService

  showDatePicker: Array<boolean> = [true, false, false, false];
  showTraveller: Array<boolean> = [false, false, false, false];
  flightActionValid: boolean = true;
  lang: string = 'en';
  startDateValue: any;
  currency?: string;
  resultLink?:
    | string
    | {
        adult: AlertMsgModel;
        child: AlertMsgModel;
        infant: AlertMsgModel;
        retDate: AlertMsgModel;
        depDate: AlertMsgModel;
      };
  selectedValue?: string;
  adultValid: boolean = true;
  childValid: boolean = true;
  infantValid: boolean = true;
  openClass: boolean = false;
  searchInput$ = new Subject<string>();
  minDate!: NgbDate;
  hoveredDate: NgbDate | null = null;
  classes: string[] = ['Economy', 'Business', 'First'];
  isSearching: boolean = false;
  isLoading: boolean = false;

  @ViewChild('multiCityCalenderTrigger_0')
  multiCityCalenderTrigger_0!: ElementRef;
  @ViewChild('multiCityCalenderTrigger_1')
  multiCityCalenderTrigger_1!: ElementRef;
  @ViewChild('multiCityCalenderTrigger_2')
  multiCityCalenderTrigger_2!: ElementRef;
  @ViewChild('multiCityCalenderTrigger_3')
  multiCityCalenderTrigger_3!: ElementRef;

  @ViewChild('mobileIssuedCountryDepart')
  mobileIssuedCountryDepart!: ElementRef;
  @ViewChild('mobileIssuedCountryLanding')
  mobileIssuedCountryLanding!: ElementRef;
  @ViewChild('departInput') departInput!: ElementRef;
  @ViewChild('landingInput') landingInput!: ElementRef;

  constructor(
    @Inject(PLATFORM_ID) private platformId: Object,
    private renderer: Renderer2,
    private modalService: NgbModal,
    public calendar: NgbCalendar,
  ) {
    this.isBrowser = isPlatformBrowser(this.platformId);
  }

  ngOnInit(): void {
    if (this.isBrowser) {
      this.initializeBrowserLogic();
    }
  }

  private initializeBrowserLogic(): void {
    this.sharedService.cities = [...this.sharedService.initialRecommendedAirports];
    this.searchInput$
      .pipe(
        debounceTime(300),
        distinctUntilChanged(),
        switchMap((searchTerm) => {
          this.isLoading = true;
          this.sharedService.cities = [];
          return this.flightSearchApi
            .getSearchFlowMapping(searchTerm)
            .pipe(
              retry(3),
              finalize(() => {
                this.isLoading = false;
              }),
            );
        }),
      )
      .subscribe({
        next: (results) => {
          this.sharedService.cities = results;
        },
        error: (err) => {
          console.error('API error:', err);
          this.isLoading = false;
        },
      });

    this.retStartDate(0);
  }

  private updateCanonicalLink(url: string): void {
    if (this.isBrowser) {
      let canonicalLink = document.querySelector('link[rel="canonical"]');
      if (canonicalLink) {
        this.renderer.setAttribute(canonicalLink, 'href', url);
      } else {
        canonicalLink = this.renderer.createElement('link');
        this.renderer.setAttribute(canonicalLink, 'rel', 'canonical');
        this.renderer.setAttribute(canonicalLink, 'href', url);
        this.renderer.appendChild(document.head, canonicalLink);
      }
    }
  }

  retStartDate(index: number) {
    let day = 0;
    let month = 0;
    let year = 0;
    if (
      this.searchbox.flightsArray.at(index).get('departingD')?.value != null
    ) {
      year = new Date(
        this.searchbox.flightsArray.at(index).get('departingD')?.value,
      ).getFullYear();
      month =
        new Date(
          this.searchbox.flightsArray.at(index).get('departingD')?.value,
        ).getMonth() + 1;
      day = Number(
        this.searchbox.flightsArray
          .at(index)
          .get('departingD')
          ?.value.toString()
          .split(' ')[2],
      );

      return (this.startDateValue = { year: year, month: month, day: day });
    } else {
      this.searchbox.flightsArray
        .at(index)
        .get('departingD')
        ?.setValue(this.calendar.getToday());
      return (this.startDateValue = this.calendar.getToday());
    }
  }

  isHovered(date: NgbDate) {
    return (
      this.startDateValue &&
      date.after(this.startDateValue) &&
      date.before(this.startDateValue)
    );
  }

  isInside(date: NgbDate) {
    return date.after(this.startDateValue) && date.before(this.startDateValue);
  }

  isRange(date: NgbDate) {
    return (
      date.equals(this.startDateValue) ||
      (this.startDateValue && date.equals(this.startDateValue)) ||
      this.isInside(date) ||
      this.isHovered(date)
    );
  }

  isDisabled(date: NgbDate) {
    return date.before(this.minDate);
  }

  showDate(index: number) {
    this.showTraveller[index] = false;
    this.showDatePicker[index] = !this.showDatePicker[index];
  }

  showMobileDate(index: number) {
    this.router.navigate([`/searchboxMob/${index}`]);
  }

  showTravellers(index: number) {
    this.showDatePicker[index] = false;
    this.showTraveller[index] = !this.showTraveller[index];
  }

  onCitySearch(event: Event) {
    const inputElement = event.target as HTMLInputElement;
    const searchTerm = inputElement.value.trim();

    if (searchTerm) {
      this.isSearching = true;
      this.searchInput$.next(searchTerm);
    } else {
      this.isSearching = false;
      this.isLoading = false;
      this.sharedService.cities = this.getRecommendedAirports();
    }
  }

  getTotalPassenger() {
    let adult = this.searchbox.searchFlight?.get('passengers.adults')?.value;
    let child = this.searchbox.searchFlight?.get('passengers.child')?.value;
    let infant = this.searchbox.searchFlight?.get('passengers.infant')?.value;
    return this.searchbox.getTotalPassengers(adult, child, infant);
  }

  onDateSelection(date: NgbDate, index: number) {
    this.searchbox.flightsArray
      .at(index)
      .get('departingD')
      ?.setValue(new Date(date.year, date.month - 1, date.day));
    this.showDatePicker[index] = false;
    this.showTraveller[index] = true;

    let errorMsg = this.searchbox.validateMultiCityDates();
    if (errorMsg.enMsg && errorMsg.enMsg != 'True') {
      if (this.lang == 'en') {
        this.tinyAlert(errorMsg.enMsg);
      } else {
        this.tinyAlert(errorMsg.arMsg);
      }
    }
    if (index == 0) {
      this.multiCityCalenderTrigger_0.nativeElement.click();
    } else if (index == 1) {
      this.multiCityCalenderTrigger_1.nativeElement.click();
    } else if (index == 2) {
      this.multiCityCalenderTrigger_2.nativeElement.click();
    } else {
      this.multiCityCalenderTrigger_3.nativeElement.click();
    }
  }

  addFlight() {
    let len = this.searchbox.flightsArray.length;

    let airport = this.sharedService.landingAirports[this.searchbox.flightsArray['controls'].length - 1];
    if(airport)
    {
      this.sharedService.departingAirports[this.searchbox.flightsArray['controls'].length] = airport;
    }

    this.searchbox.addFlight();
    if (len >= 4) {
      this.flightActionValid = false;
    }
  }

  removeFlight() {
    this.searchbox.removeFlight();
    let len = this.searchbox.flightsArray.length;
    if (len <= 1) {
      this.flightActionValid = true;
    }
  }

  removeInput(inputType: string, index: number) {
    if (inputType == 'depart') {
      (<FormArray>this.searchbox.searchFlight?.get('Flights'))
        .at(index)
        .get('departing')
        ?.reset();
    } else {
      (<FormArray>this.searchbox.searchFlight?.get('Flights'))
        .at(index)
        .get('landing')
        ?.reset();
    }
    this.searchbox.searchFlight.updateValueAndValidity();
  }

  // Type guard to check if resultLink is of type ResultLinkObject
  isResultLinkObject(resultLink: unknown): resultLink is ResultLinkObject {
    return (
      typeof resultLink === 'object' &&
      resultLink !== null &&
      'adult' in resultLink &&
      'child' in resultLink &&
      'infant' in resultLink &&
      'retDate' in resultLink &&
      'depDate' in resultLink
    );
  }
  submit() {
    this.lang =
      this.translate.currentLang != null ? this.translate.currentLang : 'en'; // Get language
    this.currency = this.homePageService.selectedCurrency.Currency_Code; // Get currency from homepage service

    // Call submit function from searchbox service
    this.resultLink = this.searchbox.onSubmit(
      this.lang,
      // this.currency,
      'EGP',
      this.homePageService.pointOfSale
        ? this.homePageService.pointOfSale.country!
        : 'EG',
      1,
      ',',
      this.sharedAirlineService.preferredAirlineIatacode,
    );

    // Use the type guard to check if resultLink is of type ResultLinkObject
    if (this.isResultLinkObject(this.resultLink)) {
      // Loop through resultLink object for validation messages
      Object.entries(this.resultLink).forEach(([key, value]) => {
        if (value.enMsg) {
          this.tinyAlert(this.lang === 'en' ? value.enMsg : value.arMsg);
        }
      });
      this.searchbox.searchFlight.updateValueAndValidity();
    } else if (typeof this.resultLink === 'string' && this.resultLink) {
      // Check if form is valid before proceeding
      if (this.searchbox.searchFlight.valid) {
        // Store form data using StorageService
        this.storageService.setItem(
          'form',
          JSON.stringify(this.searchbox.searchFlight.value),
        );
        this.sharedService.saveSelectedAirportsInStorage();

        // Construct external URL
        const externalBase = 'https://flight.travasky.com/flightResult/';
        const splittedLink = this.resultLink.toString().split('/');
        const externalUrl = externalBase + splittedLink.join('/');

        // Redirect to external site
        if (isPlatformBrowser(this.platformId)) {
          window.location.href = externalUrl + '?form=' + JSON.stringify(this.searchbox.searchFlight.value);
        }
      } else {
        this.searchbox.searchFlight.markAllAsTouched();
      }
    }
  }

  tinyAlert(message: any) {
    Swal.fire({
      icon: 'error',
      title: 'Oops...',
      text: message,
    });
  }

  changeAdultValue(action: string) {
    if (this.searchbox.searchFlight?.get('passengers.adults')?.value >= 9) {
      if (action == 'increase') {
        this.searchbox.searchFlight?.get('passengers.adults')?.setValue(9);
        this.adultValid = false;
      } else {
        this.searchbox.searchFlight
          ?.get('passengers.adults')
          ?.setValue(
            this.searchbox.searchFlight?.get('passengers.adults')?.value - 1,
          );
        this.adultValid = true;
      }
    } else if (
      this.searchbox.searchFlight?.get('passengers.adults')?.value <= 1
    ) {
      if (action == 'increase') {
        this.searchbox.searchFlight
          ?.get('passengers.adults')
          ?.setValue(
            this.searchbox.searchFlight?.get('passengers.adults')?.value + 1,
          );
        this.adultValid = true;
      } else {
        this.searchbox.searchFlight?.get('passengers.adults')?.setValue(1);
      }
    } else {
      this.adultValid = true;
      if (action == 'increase') {
        this.searchbox.searchFlight
          ?.get('passengers.adults')
          ?.setValue(
            this.searchbox.searchFlight?.get('passengers.adults')?.value + 1,
          );
      } else {
        this.searchbox.searchFlight
          ?.get('passengers.adults')
          ?.setValue(
            this.searchbox.searchFlight?.get('passengers.adults')?.value - 1,
          );
      }
    }
  }

  changeChildValue(action: string) {
    if (action == 'increase') {
      this.searchbox.searchFlight
        ?.get('passengers.child')
        ?.setValue(
          this.searchbox.searchFlight?.get('passengers.child')?.value + 1,
        );
      this.childValid = true;
      if (this.searchbox.searchFlight?.get('passengers.child')?.value >= 8) {
        this.searchbox.searchFlight?.get('passengers.child')?.setValue(8);
        this.childValid = false;
      }
    } else {
      this.searchbox.searchFlight
        ?.get('passengers.child')
        ?.setValue(
          this.searchbox.searchFlight?.get('passengers.child')?.value - 1,
        );
      this.childValid = true;
      if (this.searchbox.searchFlight?.get('passengers.child')?.value <= 0) {
        this.searchbox.searchFlight?.get('passengers.child')?.setValue(0);
        this.childValid = true;
      }
    }
  }

  changeInfantValue(action: string) {
    let adultValue =
      this.searchbox.searchFlight?.get('passengers.adults')?.value;
    if (action == 'increase') {
      this.searchbox.searchFlight
        ?.get('passengers.infant')
        ?.setValue(
          this.searchbox.searchFlight?.get('passengers.infant')?.value + 1,
        );
      this.infantValid = true;
      let infantValue =
        this.searchbox.searchFlight?.get('passengers.infant')?.value;
      if (infantValue > 4) {
        this.searchbox.searchFlight?.get('passengers.infant')?.setValue(4);
        this.infantValid = false;
      }
      if (infantValue > adultValue) {
        this.searchbox.searchFlight
          ?.get('passengers.infant')
          ?.setValue(adultValue);
        this.infantValid = false;
      }
    } else {
      this.searchbox.searchFlight
        ?.get('passengers.infant')
        ?.setValue(
          this.searchbox.searchFlight?.get('passengers.infant')?.value - 1,
        );
      this.infantValid = false;
      if (this.searchbox.searchFlight?.get('passengers.infant')?.value <= 0) {
        this.searchbox.searchFlight?.get('passengers.infant')?.setValue(0);
        this.infantValid = true;
      }
    }
  }

  stopMenuClosing(event: any) {
    event.stopPropagation();
  }

  InFlightResult(): boolean {
    const currentUrl = this.router.url;
    return currentUrl.includes('flightResult');
  }

  openDepartAirport(depart: TemplateRef<any>) {
    this.searchbox.flightsArray.at(0).get('departing')?.setValue('');
    this.modalService.open(depart, { fullscreen: true });
    setTimeout(() => {
      document.getElementById('departInput')?.focus();
    }, 300);
  }

  onSelectLandingCity(city: IAirPortTranslated, index: number) {
    this.sharedService.onSelectLandingAirports(city, index);
  }

  onSelectDepartingCity(city: IAirPortTranslated, index: number) {
    this.sharedService.onSelectDepartingAirports(city, index);
  }

  assignCountriesForMobileD(departCountry: any, index: number, city: IAirPortTranslated) {
    const mobileInput = this.mobileIssuedCountryDepart.nativeElement;

    this.sharedService.onSelectDepartingAirports(city, index);

    if (mobileInput) {
      mobileInput.value = departCountry;
      this.searchbox.flightsArray
        .at(index)
        .get('departing')
        ?.setValue(departCountry);
    }
    this.modalService.dismissAll();
  }

  openLandingAirport(landing: TemplateRef<any>) {
    this.modalService.open(landing, { fullscreen: true });
    setTimeout(() => {
      document.getElementById('landingInput')?.focus();
    }, 300);
  }

  assignCountriesForMobileA(landingCountry: any, index: number, city: IAirPortTranslated) {
    this.sharedService.onSelectLandingAirports(city, index);

    this.searchbox.flightsArray
      .at(index)
      .get('landing')
      ?.setValue(landingCountry);

    this.modalService.dismissAll();
  }

  onSearchInputChange(event: any) {
    const inputValue = (event.target as HTMLInputElement)?.value || '';
    this.isSearching = inputValue.trim().length > 0;
  }

  getRecommendedAirports(): IAirPortTranslated[] {
    return this.sharedService.initialRecommendedAirports
  }
}
